<template>
    <v-container fluid>   

        <!-- Headline with Shipping Document number and Recipient -->
        <div v-if="$i18n.locale!='ja'">
            <v-col>
                <v-row class="pl-4 headline">
                    {{ $t(getLangOfType(item.type)) }} {{ item.number }} 
                    {{ $t('lang_GENERAL_CAPTION_EDIT_PAGE_TITLE_FOR') }} 
                    {{ item.recipientName }}
                </v-row>
            </v-col>
        </div>
        <div v-else>
            <v-col>
                <v-row class="pl-4 headline">
                    {{ item.recipientName }} 
                    {{ $t('lang_GENERAL_CAPTION_EDIT_PAGE_TITLE_FOR') }} 
                    {{ $t(getLangOfType(item.type)) }} {{ item.number }}
                </v-row>
            </v-col>
        </div>

        <v-row class="pl-4 pr-4">

            <!-- Column with Recipient (invoice address) -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.recipientFullAddress !== null">
                            <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_RECIPIENT_ADDRESS_INVOICE') }}</div> 
                            <div v-html="item.recipientFullAddress"></div>
                        </span>
                        <span v-if="item.recipientVatId !== null">
                            <div class="read-only-caption">{{ $t('lang_GENERIC_CAPTION_VAT_ID') }}</div> 
                            <div v-html="item.recipientVatId"></div>
                        </span>

                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Recipient (shipping address) -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.recipientFullShippingAddress !== null">
                            <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_RECIPIENT_ADDRESS_SHIPPING') }}</div> 
                            <div v-html="item.recipientFullShippingAddress"></div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Sender -->
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="item.senderFullAddress !== null">
                            <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_SENDER_ABBREVIATION') }}</div> 
                            <div v-html="item.senderFullAddress"></div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>

        <v-row class="pl-4 pr-4">

            <!-- Column with Note for Recipient -->
            <v-col cols="6">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- <span v-if="(item.noteForRecipient !== null && item.noteForRecipient !== '')"> -->

                            <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_NOTE_FOR_RECIPIENT') }}</div> 
                            <div v-html="item.noteForRecipient" />
                        <!-- </span> -->
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Number and ALVID -->
            <v-col cols="3">
                <v-card elevation="0">
                    <v-card-text>
                        <span v-if="(item.number !== null && item.number !== '')">
                            <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_NUMBER_FULLTEXT') }}</div>
                            <div>{{ item.number }}</div>
                        </span>

                        <div class="read-only-caption">{{ $t('lang_CAPTION_ALVID') }}</div>
                        <div>{{ item.alvId }}</div>

                        <span v-if="item.recipientTransactionNumber !== null && item.recipientTransactionNumber !== undefined">
                            <div class="read-only-caption">{{ $t('lang_ERP_CAPTION_TRANSACTION_NUMBER') }}</div>
                            <div v-html="item.recipientTransactionNumber"></div>
                        </span>

                        <div class="read-only-caption">
                            {{ $t('lang_GENERIC_CAPTION_CREATED') }}
                        </div>
                        <div v-if="item.created !== undefined">
                            {{ item.created.name }}, {{ $d(new Date(item.created.date), 'alvDateTime',  $i18n.locale) }}
                        </div>

                        <div class="read-only-caption">
                            {{ $t('lang_GENERIC_CAPTION_LAST_UPDATED') }}
                        </div>
                        <div v-if="item.lastUpdated !== undefined">
                            {{ item.lastUpdated.name }}, {{ $d(new Date(item.lastUpdated.date), 'alvDateTime',  $i18n.locale) }}
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Column with Date and Status -->
            <v-col cols="3">
                <v-card elevation="0">
                    <v-card-text>
                        <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_DATE_ABBREVIATION') }}</div>
                        <div>{{ $d(new Date(item.date), 'alvDateFormat', this.$i18n.locale) }}</div>

                        <div class="read-only-caption">{{ $t('lang_ERP_SHIPPING_CAPTION_STATUS') }}</div>
                        <div>{{ $t(getLangOfStatus(item.status)) }}</div>

                        <div class="read-only-caption">{{ $t('lang_GENERAL_CAPTION_LANGUAGE') }}</div>
                        <div>{{ $t(getLangOfLang(item.language)) }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        
        </v-row>
        
        <!-- Table with Shipping Rows -->
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat :value="[0]">
                    <ShippingRowsReadOnlyPanel :shippingAlvId="item.alvId"/>
                </v-expansion-panels>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

    import ShippingRowsReadOnlyPanel from './_panels/1_shippingrows/ShippingRowsReadOnlyPanel'
    import {    DropdownErpShippingStatus, 
                DropdownErpShippingType 
                } from '@/assets/dropdowns/alvDropdowns.js'

    export default {
        name: "ShippingReadOnly",
        components: {
            ShippingRowsReadOnlyPanel,
            DropdownErpShippingType,
            DropdownErpShippingStatus,
        },
        props: {
            itemId: {
                type: Number
            }
        },
        computed: {
            item() {
                let item = this.$store.getters.getExpandedShipping.find(element => {
                    return element.id === this.itemId
                })
                return item
            },
        },
        methods: {
            getLangOfType(selection, type = "text") {
                return DropdownErpShippingType.find(obj => {
                    return obj.value == selection
                })[type]
            },
            getLangOfStatus(selection) {
                return DropdownErpShippingStatus.find(obj => {
                    return obj.value == selection
                }).text
            },
            getLangOfLang(langCode) {
                let languages = this.$store.getters.getGeneralLanguages
                if(languages != null) {
                    let object = languages.find(obj => {
                        return obj.value == langCode
                    })
                    if (object) {
                        return object.text
                    } else return 'Shyriiwook'
                }
            },
        },
    }
</script>